import React from "react";
import { Link } from "react-router-dom";
import { CircleUserRound } from "lucide-react";
import { buttonVariants } from "../ui/button";
import BackIcon from "../back-icon";

interface Doctor {
  fullName: string;
  profilePhoto?: string;
  specialities?: string[];
  subDistrictOrCity?: string;
  fee?: string;
}

interface Props {
  doctor?: Doctor;
}

const DoctorDetailsCard: React.FC<Props> = ({ doctor }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm mb-6">
      <div className="flex gap-3">
        <Link
          to={`/doctors`}
          className={`${buttonVariants({
            variant: "ghost",
            size: "icon",
          })} group relative hover:bg-gray-100 transition-colors`}
        >
          <BackIcon />
          <span className="absolute left-1/2 top-full mt-1 hidden -translate-x-1/2 items-center rounded bg-gray-800 p-1 text-xs text-white shadow-lg group-hover:flex">
            Back
          </span>
        </Link>

        {doctor?.profilePhoto ? (
          <img
            src={`${doctor?.profilePhoto}`}
            alt={doctor?.fullName}
            className="size-16 rounded-full object-contain sm:size-24 border-2 "
          />
        ) : (
          <div className="flex size-16 shrink-0 items-center justify-center rounded-full bg-muted sm:size-20 border-2 ">
            <CircleUserRound className="size-full" strokeWidth={1} />
          </div>
        )}

        <div className="w-full space-y-4">
          <div>
            <h3 className="text-sm font-bold sm:text-xl">Dr {doctor?.fullName}</h3>
            {doctor?.specialities?.length && (
              <p className="mb-1 text-xs text-muted-foreground sm:text-base">
                {doctor?.specialities.join(", ")}
              </p>
            )}
            <p className="mb-1 text-xs font-bold text-muted-foreground sm:text-base">
              {doctor?.subDistrictOrCity}
            </p>
            <p className="mb-2 text-sm  font-semibold sm:text-base">
              Fee: <span className="">₹{doctor?.fee ? doctor?.fee : "NA"}</span>
            </p>

            {/* <div className="flex justify-end m-2">
                  <button
                    onClick={() => setIsModalOpen(true)}
                    className={buttonVariants({
                      className: "shadow-md hover:shadow-lg transition-shadow px-2 py-1 text-xs", // Even smaller
                      variant: "secondary",
                    })}
                  >
                    Cancel appointment
                  </button>
                </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoctorDetailsCard;
